export default __webpack_public_path__ + "static/media/atza-events.4eaf38d4.jpg";